export class DigitalSignSimpleClauseModel {
	static MODE_FIXED = 'FIXED';
	id: string;
	values: boolean[];
	text: string;
	mode: string;

	constructor(id: string, text: string, mode: string, length: number) {
		this.id = id;
		this.values = Array(length).fill(false);
		this.text = text;
		this.mode = mode;
	}
}
